import yup, { canItems } from 'schemas/validation/feature'
import { isNumber } from 'utils/types'

import signalSchema from './signalSchema'

const scalingQuerySchema = yup.object({
  ...canItems,
  signal: signalSchema,
  subType: yup.string(),
  // TODO: DRY
  valueMin: yup
    .number()
    .when(['signal', 'subType'], (ctxSignal, subType, schema) =>
      ctxSignal || subType
        ? yup
            .number()
            .required()
            .inInputRange(ctxSignal, subType)
            .lessThanContext('valueMax')
        : schema
    )
    .when(['$minValue', '$maxValue'], (minValue, maxValue, schema) =>
      isNumber(minValue) && isNumber(maxValue)
        ? yup
            .number()
            .required()
            .min(minValue)
            .max(maxValue)
            .lessThanContext('valueMax')
        : schema
    ),
  valueMax: yup
    .number()
    .when(['signal', 'subType'], (ctxSignal, subType, schema) =>
      ctxSignal || subType
        ? yup
            .number()
            .required()
            .inInputRange(ctxSignal, subType)
            .moreThanContext('valueMin')
        : schema
    )
    .when(['$minValue', '$maxValue'], (minValue, maxValue, schema) =>
      isNumber(minValue) && isNumber(maxValue)
        ? yup
            .number()
            .required()
            .min(minValue)
            .max(maxValue)
            .moreThanContext('valueMin')
        : schema
    ),
})

export default scalingQuerySchema
